import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const Footer = () => {
  return (
    <footer className="bg-muted/40 text-muted-foreground py-16 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Logo to="" size="md" />
            <p className="mt-4 text-sm leading-relaxed font-body">
              Plataforma brasileira de permuta imobiliária inteligente, especializada no estado de São Paulo. Motor de compatibilidade, permutas em cadeia e liquidez automática.
            </p>
            <p className="mt-3 text-xs text-muted-foreground font-body">
              Um projeto Casa87 Imóveis & @petersonabq
            </p>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Imóveis</h3>
            <ul className="space-y-2 text-sm font-body">
              <li><Link to="/signup" className="hover:text-accent transition-colors">Casas</Link></li>
              <li><Link to="/signup" className="hover:text-accent transition-colors">Apartamentos</Link></li>
              <li><Link to="/signup" className="hover:text-accent transition-colors">Terrenos</Link></li>
              <li><Link to="/signup" className="hover:text-accent transition-colors">Comerciais</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Plataforma</h3>
            <ul className="space-y-2 text-sm font-body">
              <li><a href="#como-funciona" className="hover:text-accent transition-colors">Como funciona</a></li>
              <li><Link to="/signup" className="hover:text-accent transition-colors">Cadastre-se</Link></li>
              <li><Link to="/corretores" className="hover:text-accent transition-colors">Para Corretores</Link></li>
              <li><a href="https://casa87imoveis.com.br" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">Casa87 Imóveis</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Suporte</h3>
            <ul className="space-y-2 text-sm font-body">
              <li><Link to="/central-de-ajuda" className="hover:text-accent transition-colors">Central de ajuda</Link></li>
              <li><Link to="/termos-de-uso" className="hover:text-accent transition-colors">Termos de uso</Link></li>
              <li><Link to="/politica-de-privacidade" className="hover:text-accent transition-colors">Política de privacidade</Link></li>
              <li><Link to="/seguranca" className="hover:text-accent transition-colors">Segurança</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm font-body">
          <p>© 2026 Permuta Digital · Casa87 Imóveis. Todos os direitos reservados.</p>
          <p className="text-muted-foreground text-xs">
            Permuta imobiliária prevista no art. 533 do Código Civil
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
